export const SuggestionList = ({ isLoading, suggestions, onAddFriend, isAddingFriend, onDeleteSuggestion }) => {
    return (
        <div className="item">
            <span>
                Suggestions For You
            </span>

            {isLoading ? (
                <span style={{ color: "gray", fontSize: "12px", padding: "10px" }}>
                    Loading...
                </span>
            ) : (!suggestions || suggestions.length === 0) ? (
                <span style={{ color: "gray", fontSize: "12px", padding: "10px" }}>
                    No suggestions available
                </span>
            ) : (
                suggestions.slice(0, 5).map((user) => (
                    <div className="user" key={user.id}>
                        <div className="userInfo">
                            <img 
                                src={user.profilePic || "/public/noAvatar.png"} 
                                alt={user.name} 
                            />
                            
                            <span>
                                {user.name}
                            </span>
                        </div>

                        <div className="buttons">
                            <button 
                                onClick={() => onAddFriend(user.id)}
                                disabled={isAddingFriend}
                                style={{ backgroundColor: "#5271ff", color: "white", border: "none", padding: "5px", cursor: "pointer" }}
                            >
                                Add Friend
                            </button>

                            <button 
                                onClick={() => onDeleteSuggestion(user.id)}
                                style={{ backgroundColor: "#f0544f", color: "white", border: "none", padding: "5px", cursor: "pointer" }}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};